// extracted by mini-css-extract-plugin
module.exports = {"shopBadge":"ShopMainPageNav_shopBadge__11Fhm","shopAvatarContainer":"ShopMainPageNav_shopAvatarContainer__1OrX9","shopName":"ShopMainPageNav_shopName__3eCLj"};